import React from "react";
import { Reveal } from "@/components/common/Reveal";
import { motion } from "framer-motion";

const CHAPTERS = [
  { n: "01", title: "Capital is a beginning.", body: "Funding is not a finish line. We treat capital as fuel for a disciplined journey — from a validated idea to a business that operates, sells and endures." },
  { n: "02", title: "From software to steel.", body: "Intelligence does not stop at a screen. We support ventures across software, marketing, robotics and manufacturing — wherever AI creates measurable value." },
  { n: "03", title: "Execution over promises.", body: "We do not guarantee outcomes. We build the conditions for them: readiness, technology, market access, manufacturing and talent, aligned to documented milestones." },
  { n: "04", title: "Structure protects everyone.", body: "Clear separation between founders, clients and partners — with consent, documentation and disclosure at every step — is how a serious platform earns trust." },
];

const MARQUEE = "VALIDATE — BUILD — PREPARE FOR CAPITAL — COMMERCIALISE — MANUFACTURE — DISTRIBUTE — SCALE — ";

export default function Manifesto() {
  return (
    <>
      <section className="relative py-24 md:py-36 border-t border-white/5" data-testid="manifesto-section">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="mb-16"><span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#00D1FF]">The FundAI Manifesto</span></div>
          <div className="space-y-24 md:space-y-32">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n}>
                <div className="grid md:grid-cols-[auto_1fr] gap-6 md:gap-16 items-start">
                  <span className="font-head text-6xl md:text-8xl font-extralight text-zinc-800 leading-none select-none">{c.n}</span>
                  <div className="max-w-2xl">
                    <h3 className="font-head text-3xl md:text-5xl font-light tracking-tight text-metallic">{c.title}</h3>
                    <p className="mt-6 text-base md:text-lg font-light text-zinc-400 leading-relaxed">{c.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <div className="border-y border-white/5 py-8 overflow-hidden" data-testid="marquee">
        <div className="marquee-track">
          {[0, 1].map((k) => (
            <span key={k} className="font-head text-3xl md:text-5xl font-extralight tracking-[0.15em] text-zinc-700 pr-8">{MARQUEE.repeat(2)}</span>
          ))}
        </div>
      </div>
    </>
  );
}
